export default __webpack_public_path__ + "static/media/sun_in_my_hand.1a2e5523.jpg";